document.addEventListener("DOMContentLoaded", function () {
  var trigger = document.querySelector(".acct-tab");
  var dropdown = document.querySelector(".show-acc-tab");
  if (!trigger || !dropdown) return;

  var hideTimer;

  function showDropdown() {
    clearTimeout(hideTimer);
    dropdown.style.display = "block";
  }

  function hideDropdown() {
    hideTimer = setTimeout(function () {
      dropdown.style.display = "none";
    }, 150);
  }

  /* Desktop: hover with debounce to bridge gap */
  if (window.innerWidth >= 768) {
    trigger.addEventListener("mouseenter", showDropdown);
    trigger.addEventListener("mouseleave", hideDropdown);
    dropdown.addEventListener("mouseenter", showDropdown);
    dropdown.addEventListener("mouseleave", hideDropdown);
  }

  /* Mobile: click toggle */
  if (window.innerWidth < 768) {
    trigger.addEventListener("click", function (e) {
      e.stopPropagation();
      if (dropdown.style.display === "none" || dropdown.style.display === "") {
        dropdown.style.display = "block";
      } else {
        dropdown.style.display = "none";
      }
    });

    var closeBtn = document.querySelector(".close-acc-tab");
    if (closeBtn) {
      closeBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        dropdown.style.display = "none";
      });
    }

    document.body.addEventListener("click", function (e) {
      if (
        dropdown.style.display === "block" &&
        !dropdown.contains(e.target) &&
        !trigger.contains(e.target)
      ) {
        dropdown.style.display = "none";
      }
    });
  }
});
